var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('ul', {
    staticClass: "topbar-right fr"
  }, [(_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.loginUrl
    }
  }, [_vm._v("[登录]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.registerUrl
    }
  }, [_vm._v("[注册]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('span', [_vm._v("您好")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.userCenterUrl
    }
  }, [_vm._v(_vm._s(_vm.account))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("[退出]")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.aboutUsUrl
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contactUrl,
      "target": "_blank"
    }
  }, [_vm._v("联系客服")])])]), _vm._v(" "), _c('ul', {
    staticClass: "topbar-left fl"
  }, [_c('li', [_vm._v("\n\t\t\t\t\t\t您好！欢迎来到相伴宝！\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "co1",
    attrs: {
      "href": _vm.indexUrl
    }
  }, [_vm._v("返回相伴宝")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header line"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": _vm.indexUrl,
      "title": "云永云商城"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortParam),
      expression: "sortParam"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.sortParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sortParam = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.findGoods()
      }
    }
  }, [_vm._v("搜商品")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-left": "3px"
    },
    on: {
      "click": function($event) {
        _vm.findShops()
      }
    }
  }, [_vm._v("搜店铺")])]), _vm._v(" "), _c('div', {
    staticClass: "r-box fr",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mycart",
    on: {
      "mouseenter": function($event) {
        _vm.shopCarShow()
      },
      "mouseleave": function($event) {
        _vm.shopCarHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("我的购物车")]), _vm._v(" "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.shoppingCartNum))]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/settleup-nogoods.png"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), _vm._v("    "), _c('span', [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.goodsPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.goodsCode)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()])]), _vm._v(" "), (_vm.isLogin == true) ? _c('div', {
    staticClass: "myorder ml25",
    on: {
      "mouseenter": function($event) {
        _vm.orderShow()
      },
      "mouseleave": function($event) {
        _vm.orderHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-orders"
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.goOrder('')
      }
    }
  }, [_vm._v("我的订单 "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.allCount))])]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "orders-list orders"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_pay')
      }
    }
  }, [_vm._v("等待买家付款 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_send_goods')
      }
    }
  }, [_vm._v("等待卖家发货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sendCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_confirm_goods')
      }
    }
  }, [_vm._v("等待确认收货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.putCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_finish')
      }
    }
  }, [_vm._v("订单完成 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.receiveCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_close')
      }
    }
  }, [_vm._v("订单关闭 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.closeCount))])])])])])]) : _vm._e()])])])]), _vm._v(" "), _c('heardernav', {
    ref: "navComp",
    attrs: {
      "isRefresh": _vm.isRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn) + _vm._s(_vm.brandName))])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-search-list"
  }, [_c('div', {
    staticClass: "l-hd"
  }, [_c('div', {
    staticClass: "top-num fr"
  }, [_vm._v("共" + _vm._s(_vm.totalItem) + "条 "), _c('span', {
    staticClass: "co2"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn))])]), _vm._v(" "), _c('h3', [_vm._v("搜索结果")])]), _vm._v(" "), _c('div', {
    staticClass: "hq-selector"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', [_vm._v("已选条件：")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "choosedCond"
    }
  }, _vm._l((_vm.choosedCondItem), function(condItem, index) {
    return _c('span', {
      staticClass: "checked-item",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "condType": condItem.condType
      }
    }, [_vm._v(_vm._s(condItem.condName)), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.removeCondition(index, condItem.condType)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('dl', [_c('dt', [_vm._v("价格：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', 'intervalAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '0,100')
      }
    }
  }, [_vm._v("0-100")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '101,200')
      }
    }
  }, [_vm._v("101-200")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '201,300')
      }
    }
  }, [_vm._v("201-300")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '301,500')
      }
    }
  }, [_vm._v("301-500")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '501,1000')
      }
    }
  }, [_vm._v("501-1000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '1001,5000')
      }
    }
  }, [_vm._v("1001-5000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '5000,')
      }
    }
  }, [_vm._v("5000以上")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("发布时间：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'timeAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneDay')
      }
    }
  }, [_vm._v("一天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'twoDay')
      }
    }
  }, [_vm._v("两天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneWeek')
      }
    }
  }, [_vm._v("一周内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneMonth')
      }
    }
  }, [_vm._v("一月内")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pro-tool mt20"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', {
    class: {
      "hover": _vm.sortCondition === "defaultSort"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('defaultSort')
      }
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "saleAmount"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('saleAmount')
      }
    }
  }, [_vm._v("销量"), _c('i', {
    class: {
      "up": _vm.sortSaleAmount == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "publishTime"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('publishTime')
      }
    }
  }, [_vm._v("发布时间"), _c('i', {
    class: {
      "up": _vm.sortPublishTime == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "price"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('price')
      }
    }
  }, [_vm._v("价格"), _c('i', {
    class: {
      "up": _vm.sortPrice == "asc"
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "price-wrap"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lower),
      expression: "lower"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lower = $event.target.value
      }
    }
  }), _vm._v(" - "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upper),
      expression: "upper"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.upper)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upper = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "price-tool"
  }, [_c('div', {
    staticClass: "price-tool-btn"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.clearUserDefined()
      }
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.userDefinedCondition()
      }
    }
  }, [_vm._v("确定")])])])])])])])])]), _vm._v(" "), (_vm.firstCatCode != 'spike') ? _c('div', {
    staticClass: "pro-list"
  }, [_c('ul', _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "img"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v(" ￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]), _vm._v(" "), _c('p', {
      staticClass: "shop"
    }, [_c('i', {
      staticClass: "ico-shop-l"
    }), _c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.shopName))])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.firstCatCode == 'spike') ? _c('div', {
    staticClass: "bd"
  }, [_c('ul', {
    staticClass: "miaosha-ul"
  }, _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "pic tc"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co3"
    }, [_vm._v("￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]), _c('span', {
      staticClass: "old"
    }, [_vm._v("￥" + _vm._s((goodsBo.marketPrice / 100).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "pinpainow_item_time"
    }, [(goodsBo.saleStatus === 'end') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t已结束                       \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距开始 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距结束 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/footer-ad-1.png"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39b5de0e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/goods/goodsClassList.vue
// module id = SHpc
// module chunks = 1